import { Injectable } from '@angular/core';

import { IEmbeddedContentLink } from 'rev-portal/scheduledEvents/common/EmbeddedContentTypes';

import { PushService } from 'rev-shared/push/PushService';

@Injectable({
	providedIn: 'root'
})
export class EmbeddedContentService {

	constructor(
		private readonly PushService: PushService
	) { }

	public addEmbeddedContentLink(webcastId: string, contentLink: IEmbeddedContentLink): Promise<any> {
		return this.PushService.dispatchCommand('scheduledEvents:AddEmbeddedContentLink', {
			webcastId,
			contentLink
		});
	}

	public updateEmbeddedContentLink(webcastId: string, contentLink: IEmbeddedContentLink): Promise<any> {
		return this.PushService.dispatchCommand('scheduledEvents:UpdateEmbeddedContentLink', {
			webcastId,
			contentLink
		});
	}

	public deleteEmbeddedContentLink(webcastId: string, contentLinkId: string): Promise<any> {
		return this.PushService.dispatchCommand('scheduledEvents:DeleteEmbeddedContentLink', {
			webcastId,
			contentLinkId
		});
	}

}
